module.exports = __webpack_public_path__ + "img/56_24.7ae97796.png";